import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import swal from 'sweetalert2';
import DOMPurify from "dompurify";
import { clearGuardianStudentDocumentations as clearDocuments, getGuardianStudentDocumentations, getSectionDocumentations } from "actions/documents";
import { clearGuardianStudentPosts as clearPosts, getGuardianStudentPosts, getSectionPosts } from "actions/posts";
import { getUnreadNotifications, updateNotificationContentRead } from "actions/notifications";
import { getGoals } from "actions";
import { PRESCHOOL } from "constants/schoolTypes";
import { getDescription } from "helpers/content";
import LoadingCards from "components/Presentation/Cards/LoadingCards";
import Date from "components/Presentation/Dates/Date";
import SectionTitle from "components/Presentation/SectionTitle";
import Block, { BlockWrapper } from "UI/Elements/Block";
import { translate, Button, Icon, Checkbox, Floating } from "@haldor/ui";
import "./_MyPosts.scss";
var MyPosts = /*#__PURE__*/function (_Component) {
  function MyPosts(props) {
    var _this;
    _classCallCheck(this, MyPosts);
    _this = _callSuper(this, MyPosts, [props]);
    _defineProperty(_this, "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var isPreschool;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            isPreschool = _this.props.activeStudent.schools.find(function (school) {
              return school.type == PRESCHOOL;
            }) != null;
            _context.next = 3;
            return _this.props.clearPosts();
          case 3:
            if (!isPreschool) {
              _context.next = 6;
              break;
            }
            _context.next = 6;
            return _this.props.clearDocuments();
          case 6:
            _this.fetchData(_this.state.page);
            if (_this.props.goals.length < 1 && isPreschool) {
              _this.props.getGoals();
            }
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "componentWillUnmount", function () {
      var isPreschool = _this.props.activeStudent.schools.find(function (school) {
        return school.type == PRESCHOOL;
      }) != null;
      _this.props.clearPosts();
      if (isPreschool) {
        _this.props.clearDocuments();
      }
    });
    _defineProperty(_this, "fetchPages", function (collections) {
      var isPreschool = _this.props.activeStudent.schools.find(function (school) {
        return school.type == PRESCHOOL;
      }) != null;
      var shouldAdd = function shouldAdd(obj) {
        if (_this.props.limit != null) {
          // Filter out important posts if limit is set
          var SevenDaysAgo = moment(obj.eventDate).subtract(7, "days");
          if (obj.important && moment().isSameOrAfter(moment(obj.published), "day") && moment(obj.eventDate).isSameOrAfter(moment(), "day") && moment().isSameOrAfter(SevenDaysAgo, "day")) {
            return false;
          }
        }
        var added = _this.state.combined.findIndex(function (combined) {
          return combined.id == obj.id;
        });
        return added == -1;
      };
      return new Promise(function (resolve) {
        var promises = [];
        collections.map(function (collection) {
          if (collection.items.length <= 0 && collection.page > collection.fetched) {
            if (collection.type == "DOCUMENTATION" && !isPreschool) {
              return collection;
            }
            collection.fetched = collection.page;
            var promise = null;
            if (_this.props.groupid != null) {
              promise = collection.fetchPage(_this.props.activeStudent.id, _this.props.groupid, collection.page, _this.pageSize, _this.state.onlyUnreadIsChecked);
            } else {
              promise = collection.fetchPage(_this.props.activeStudent.id, collection.page, _this.pageSize, _this.state.onlyUnreadIsChecked);
            }
            promises.push(promise);
          }
          return collection;
        });
        Promise.all(promises).then(function () {
          collections.map(function (collection) {
            var posts = _this.props.posts;
            var documentations = _this.props.documentations;
            if (_this.props.groupid != null) {
              posts = _this.props.sectionPosts;
              documentations = _this.props.sectionDocumentations;
            }
            switch (collection.type) {
              case "POST":
                collection.items = posts.map(function (obj) {
                  return _objectSpread(_objectSpread({}, obj), {}, {
                    type: "POST"
                  });
                }).filter(shouldAdd);
                return collection;
                break;
              case "DOCUMENTATION":
                collection.items = documentations.map(function (obj) {
                  return _objectSpread(_objectSpread({}, obj), {}, {
                    type: "DOCUMENTATION"
                  });
                }).filter(shouldAdd);
                return collection;
                break;
            }
          });
          resolve(collections);
        });
      });
    });
    _defineProperty(_this, "paginationSort", function () {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve) {
          var sortItems, limit, combined, collection, _loop;
          return _regeneratorRuntime.wrap(function _callee2$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                // Offset start and end date by 1 day bc <>
                sortItems = function sortItems(a, b) {
                  return moment(b.published).unix() - moment(a.published).unix();
                };
                limit = _this.pageSize * page;
                combined = JSON.parse(JSON.stringify(_this.state.combined));
                collection = [].concat(_toConsumableArray(_this.collections[0].items), _toConsumableArray(_this.collections[1].items)).sort(sortItems);
                if (!(collection.length == 0)) {
                  _context3.next = 9;
                  break;
                }
                _context3.next = 7;
                return _this.fetchPages(_this.collections);
              case 7:
                _this.collections = _context3.sent;
                collection = [].concat(_toConsumableArray(_this.collections[0].items), _toConsumableArray(_this.collections[1].items)).sort(sortItems);
              case 9:
                if (_this.props.limit != null) {
                  limit = _this.props.limit;
                }
                _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                  var item, collectionInfo, index;
                  return _regeneratorRuntime.wrap(function _loop$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        item = collection.shift();
                        if (!(item != null)) {
                          _context2.next = 18;
                          break;
                        }
                        combined.push(item);
                        collectionInfo = _this.collections.find(function (obj) {
                          return obj.type == item.type;
                        });
                        if (!(collectionInfo != null)) {
                          _context2.next = 16;
                          break;
                        }
                        index = collectionInfo.items.findIndex(function (obj) {
                          return obj.id == item.id && obj.type == item.type;
                        });
                        if (index > -1) {
                          collectionInfo.items.splice(index, 1);
                        }
                        if (item.type == "POST") {
                          _this.collections[0] = collectionInfo;
                        } else {
                          _this.collections[1] = collectionInfo;
                        }
                        if (!(collectionInfo.items.length <= 0)) {
                          _context2.next = 16;
                          break;
                        }
                        //Fetch next page
                        collectionInfo.page += 1;
                        _context2.next = 12;
                        return _this.setState({
                          combined: combined
                        });
                      case 12:
                        _context2.next = 14;
                        return _this.fetchPages(_this.collections);
                      case 14:
                        _this.collections = _context2.sent;
                        collection = [].concat(_toConsumableArray(_this.collections[0].items), _toConsumableArray(_this.collections[1].items)).sort(sortItems);
                      case 16:
                        _context2.next = 19;
                        break;
                      case 18:
                        return _context2.abrupt("return", 1);
                      case 19:
                      case "end":
                        return _context2.stop();
                    }
                  }, _loop);
                });
              case 11:
                if (!(combined.length < limit)) {
                  _context3.next = 17;
                  break;
                }
                return _context3.delegateYield(_loop(), "t0", 13);
              case 13:
                if (!_context3.t0) {
                  _context3.next = 15;
                  break;
                }
                return _context3.abrupt("break", 17);
              case 15:
                _context3.next = 11;
                break;
              case 17:
                _context3.next = 19;
                return _this.setState({
                  combined: combined
                });
              case 19:
                resolve(1);
              case 20:
              case "end":
                return _context3.stop();
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    });
    _defineProperty(_this, "fetchData", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(page) {
        return _regeneratorRuntime.wrap(function _callee3$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this.setState({
                appending: true
              });
              _context4.next = 3;
              return _this.paginationSort(page);
            case 3:
              _this.setState({
                appending: false
              });
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee3);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "loadMore", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var page, newPage;
      return _regeneratorRuntime.wrap(function _callee4$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            page = _this.state.page;
            if (!_this.state.appending) {
              _context5.next = 3;
              break;
            }
            return _context5.abrupt("return", false);
          case 3:
            newPage = page + 1;
            _this.setState({
              appending: true
            });
            _context5.next = 7;
            return _this.paginationSort(newPage);
          case 7:
            _this.setState({
              page: newPage,
              appending: false
            });
          case 8:
          case "end":
            return _context5.stop();
        }
      }, _callee4);
    })));
    _defineProperty(_this, "resetCollectionProgress", function () {
      _this.collections = _this.collections.map(function (collection) {
        collection.page = 1;
        collection.fetched = 0;
        collection.items = [];
        return collection;
      });
    });
    _defineProperty(_this, "renderContent", function () {
      var combined = _this.state.combined;
      if (combined.length > 0) {
        return /*#__PURE__*/React.createElement(BlockWrapper, {
          cols: 3
        }, combined != null ? combined.map(function (document) {
          return _this.renderDocument(document);
        }) : null);
      }
      if (_this.state.appending) {
        return null;
      }
      return /*#__PURE__*/React.createElement("h3", {
        style: {
          textAlign: "center"
        }
      }, _this.props.translate("No posts was found"));
    });
    _defineProperty(_this, "headerContent", function (document) {
      var unread = false;
      if (_this.props.unreadNotifications != null && _this.props.unreadNotifications.notifications != null && _this.props.unreadNotifications.notifications.length > 0) {
        unread = _this.props.unreadNotifications.notifications.some(function (n) {
          return n.referenceType == document.type && n.referenceId == document.id && n.studentId == _this.props.activeStudent.id;
        });
      }
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          "float": "left",
          display: 'inline-flex'
        }
      }, unread ? /*#__PURE__*/React.createElement("div", {
        className: "unread-container"
      }, /*#__PURE__*/React.createElement("span", {
        className: "unread-dot"
      })) : null, document.author != null ? typeof document.author == "string" ? document.author : "".concat(document.author.firstName != null ? document.author.firstName : "", " ").concat(document.author.lastName != null ? document.author.lastName : "") : " "), /*#__PURE__*/React.createElement("div", {
        style: {
          "float": "right"
        }
      }, document.published != null ? /*#__PURE__*/React.createElement(Date, null, moment.utc(document.published).local()) : null), document.important && document.eventDate != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          "float": "left"
        }
      }) : null, document.important && document.eventDate != null && moment() <= moment(document.eventDate) ? /*#__PURE__*/React.createElement("div", {
        style: {
          "float": "right"
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          color: "red",
          fontSize: "0.9em",
          marginRight: "8px"
        }
      }, _this.props.translate("Important"))) : null, /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }));
    });
    _defineProperty(_this, "content", function (document) {
      if (document.type == "POST") {
        var strippedDescription = "";
        if (document.abbreviatedDescription != null) {
          strippedDescription = getDescription(document.abbreviatedDescription).replace(/(<([^>]+)>)/gi, "");
          if (strippedDescription.length > 99) {
            strippedDescription = strippedDescription.slice(0, 100) + "…";
          }
        }
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, document.title), /*#__PURE__*/React.createElement("p", {
          style: {
            overflow: "hidden",
            textOverflow: "ellipsis"
          },
          dangerouslySetInnerHTML: {
            __html: strippedDescription
          }
        }));
      } else {
        if (document.description) {
          var _strippedDescription = getDescription(document.description).replace(/(<([^>]+)>)/gi, "");
          if (_strippedDescription.length > 99) {
            _strippedDescription = _strippedDescription.slice(0, 100) + "…";
          }
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, document.title), /*#__PURE__*/React.createElement("p", {
            style: {
              overflow: "hidden",
              textOverflow: "ellipsis"
            },
            dangerouslySetInnerHTML: {
              __html: _strippedDescription
            }
          }));
        }
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, document.title));
      }
    });
    _defineProperty(_this, "footerContent", function (document) {
      var goals = _this.props.goals;
      if (document.associatedGoals && document.associatedGoals.length > 0) {
        var groups = [];
        if (goals && goals.length > 0) {
          goals.map(function (goal) {
            var inDocument = document.associatedGoals.find(function (goalOb) {
              return goalOb.goalId == goal.id;
            });
            if (typeof inDocument != "undefined") {
              var inArray = groups.findIndex(function (i) {
                return i.name == goal.group;
              });
              if (inArray > -1) {
                return groups[inArray].count++;
              } else {
                var group = {
                  name: goal.group,
                  color: goal.colorCode,
                  count: 1
                };
                return groups.push(group);
              }
            }
          });
        }
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, _this.props.translate("Goals")), groups.length > 0 ? /*#__PURE__*/React.createElement("div", {
          className: "goal-preview-container"
        }, groups.map(function (group) {
          return /*#__PURE__*/React.createElement("div", {
            key: "goal-" + group.name,
            className: "goal-preview",
            style: {
              backgroundColor: group.color
            }
          }, group.name, " (", group.count, ")");
        })) : null);
      } else {
        return null;
      }
    });
    _defineProperty(_this, "renderDocument", function (document) {
      var _file;
      if (_this.props.limit != null && document.important && moment().isSameOrAfter(moment(document.published), "day") && moment(document.eventDate).isSameOrAfter(moment(), "day") && moment().isSameOrAfter(moment(document.eventDate).subtract(7, "days"), "day")) {
        return null;
      }
      var expireDate = moment(document.validUntil).hour(23).minute(59);
      if (_this.props.limit != null && document.validUntil != null && expireDate.diff(moment()) < 0) {
        return null;
      }
      var link = "";
      if (document.type == "POST") {
        link = "/posts/" + document.id;
      } else {
        link = "/documents/".concat(document.id);
      }
      var file = null;
      if (document.associatedFiles != null && document.associatedFiles.length > 0) {
        file = document.associatedFiles.find(function (file) {
          return file.type && file.type.indexOf("image") > -1;
        });
      }
      return /*#__PURE__*/React.createElement(Block, {
        key: document.id,
        headerContent: _this.headerContent(document),
        image: (_file = file) === null || _file === void 0 ? void 0 : _file.url,
        content: _this.content(document),
        footerContent: _this.footerContent(document),
        link: link
      });
    });
    _defineProperty(_this, "handleShowOnlyUnreads", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var isPreschool;
      return _regeneratorRuntime.wrap(function _callee5$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _this.setState(function (prevState) {
              return {
                onlyUnreadIsChecked: !prevState.onlyUnreadIsChecked,
                combined: []
              };
            });
            isPreschool = _this.props.activeStudent.schools.find(function (school) {
              return school.type == PRESCHOOL;
            }) != null;
            if (!isPreschool) {
              _context6.next = 5;
              break;
            }
            _context6.next = 5;
            return _this.props.clearDocuments();
          case 5:
            _context6.next = 7;
            return _this.props.clearPosts();
          case 7:
            _this.resetCollectionProgress();
            _this.fetchData(_this.state.page);
            if (_this.props.goals.length < 1 && isPreschool) {
              _this.props.getGoals();
            }
          case 10:
          case "end":
            return _context6.stop();
        }
      }, _callee5);
    })));
    _defineProperty(_this, "handleMarkAllAsRead", function () {
      swal({
        title: _this.props.translate('Are you sure?'),
        text: _this.props.translate('Are you sure you want to mark all as read'),
        showCancelButton: true,
        cancelButtonText: _this.props.translate('No, cancel'),
        confirmButtonText: _this.props.translate('Yes')
      }).then(function (result) {
        if (result.value != null && _this.props.unreadNotifications.notifications != null && _this.props.unreadNotifications.notifications.length > 0) {
          var unreadPostAndDocumentationList = _this.props.unreadNotifications.notifications.filter(function (n) {
            return (n.referenceType == 'POST' || n.referenceType == 'DOCUMENTATION') && n.studentId == _this.props.activeStudent.id;
          });
          if (unreadPostAndDocumentationList != null) {
            return new Promise(function (resolve) {
              _this.props.updateNotificationContentRead(unreadPostAndDocumentationList).then(function () {
                resolve(1);
                if (_this.state.onlyUnreadIsChecked) {
                  _this.setState({
                    combined: []
                  });
                }
                _this.props.getUnreadNotifications(_this.props.activeStudent.id);
              });
            });
          }
        }
      });
    });
    _this.state = {
      appending: false,
      page: 1,
      combined: [],
      onlyUnreadIsChecked: false
    };
    _this.collections = [{
      type: "POST",
      items: [],
      fetched: 0,
      page: 1,
      fetchPage: _this.props.getGuardianStudentPosts,
      unread: _this.state.onlyUnreadIsChecked
    }, {
      type: "DOCUMENTATION",
      items: [],
      fetched: 0,
      page: 1,
      fetchPage: _this.props.getGuardianStudentDocumentations,
      unread: _this.state.onlyUnreadIsChecked
    }];
    if (props.groupid != null) {
      _this.collections = _this.collections.map(function (collection) {
        if (collection.type == "POST") {
          collection.fetchPage = _this.props.getSectionPosts;
        }
        if (collection.type == "DOCUMENTATION") {
          collection.fetchPage = _this.props.getSectionDocumentations;
        }
        return collection;
      });
    }
    _this.pageSize = _this.props.limit === 3 ? 6 : 15;
    return _this;
  }
  _inherits(MyPosts, _Component);
  return _createClass(MyPosts, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
        appending = _this$state.appending,
        combined = _this$state.combined;
      var limit = this.props.limit;
      var importantPosts = [];
      if (limit != null) {
        this.props.posts.forEach(function (post) {
          var SevenDaysAgo = moment(post.eventDate).subtract(7, "days");
          if (post.important && moment().isSameOrAfter(moment(post.published), "day") && moment(post.eventDate).isSameOrAfter(moment(), "day") && moment().isSameOrAfter(SevenDaysAgo, "day")) {
            importantPosts.push(post);
          }
        });
        importantPosts.sort(function (a, b) {
          return moment(a.eventDate) - moment(b.eventDate);
        });
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "preschooldocuments"
      }, importantPosts.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "post-content",
        style: {
          borderBottom: "1px solid #DFE1E2",
          marginBottom: "3.2em",
          paddingBottom: "1.9em"
        }
      }, /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement(Icon, {
        name: "Post"
      }), /*#__PURE__*/React.createElement("span", null, this.props.translate("Important posts"))), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: "both"
        }
      }), importantPosts.map(function (post) {
        return /*#__PURE__*/React.createElement(Link, {
          to: "/posts/".concat(post.id),
          style: {
            display: "inline-block",
            textDecoration: "none",
            color: "inherit"
          },
          key: post.id
        }, /*#__PURE__*/React.createElement("div", {
          className: "block-container",
          style: {
            display: "inline-block",
            margin: "5px"
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "block-content",
          style: {
            padding: "0.8rem"
          }
        }, /*#__PURE__*/React.createElement("h3", null, post.title))));
      })) : null, limit != null ? /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement(Icon, {
        name: "Post"
      }), /*#__PURE__*/React.createElement("span", null, this.props.translate("Recent Posts"))) : null, /*#__PURE__*/React.createElement("div", {
        className: "posts-section-container"
      }, limit == null ? /*#__PURE__*/React.createElement("div", {
        className: "post-button-container"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.handleMarkAllAsRead,
        disabled: this.props.unreadNotifications.notifications != null && this.props.unreadNotifications.notifications.length > 0 && this.props.unreadNotifications.notifications.some(function (n) {
          return n.referenceType == 'POST' || n.referenceType == 'DOCUMENTATION';
        }).length > 0 ? true : this.props.unreadNotifications.notifications == null || this.props.unreadNotifications.notifications.length == 0 || combined.length == 0 ? true : false
      }, this.props.translate("Mark all as read"))) : null, /*#__PURE__*/React.createElement("div", {
        className: "posts-content"
      }, this.renderContent(), appending ? /*#__PURE__*/React.createElement(LoadingCards, {
        count: 3
      }) : null, !appending && limit == null && combined.length > 0 ? /*#__PURE__*/React.createElement(Fragment, null, this.state.combined.length % this.pageSize < 1 || this.state.combined.length == this.pageSize * this.state.page ? /*#__PURE__*/React.createElement(Button, {
        style: {
          margin: "2em auto",
          display: "block"
        },
        type: "secondary",
        onClick: this.loadMore
      }, this.props.translate("Load more")) : null) : null, limit != null && !appending ? /*#__PURE__*/React.createElement(Link, {
        to: "/posts",
        className: "show-more-posts"
      }, this.props.translate("Show more posts")) : null), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: "both"
        }
      })));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    activeStudent: state.User.activeStudent,
    translate: translate(state.Languages.translations),
    documentations: state.documents.documentations,
    posts: state.posts.posts,
    unreadNotifications: state.Notifications.unreadNotifications,
    sectionDocumentations: state.documents.sectionDocumentations,
    sectionPosts: state.posts.sectionPosts,
    goals: state.base.goals
  };
}
export default connect(mapStateToProps, {
  getGuardianStudentPosts: getGuardianStudentPosts,
  getSectionPosts: getSectionPosts,
  getGuardianStudentDocumentations: getGuardianStudentDocumentations,
  getSectionDocumentations: getSectionDocumentations,
  getGoals: getGoals,
  getUnreadNotifications: getUnreadNotifications,
  updateNotificationContentRead: updateNotificationContentRead,
  clearDocuments: clearDocuments,
  clearPosts: clearPosts
})(MyPosts);